import React, {createContext} from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import UserStore from "./store/UserStore";
import BookStore from "./store/BookStore";
import { GoogleOAuthProvider } from "@react-oauth/google";
import PoolStore from "./store/PoolStore";
import AffiliateStore from "./store/AffiliateStore";

export const Context = createContext(null)
const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <Context.Provider value={{
      user: new UserStore(),
      book: new BookStore(),
      poolStore: new PoolStore(),
      affiliateStore: new AffiliateStore(),
      }}>

      <GoogleOAuthProvider clientId={googleClientId}>
          <App />
      </GoogleOAuthProvider>,

  </Context.Provider>


);


